import Vue from 'vue';

export default (context, interval, username, onboarding = false) => {
  username = username.replace("+", "%2B");
  return Vue.$http.get('/airlock/status?username=' + username).then((response) => {
    if(response.data.status == 1) {
      if(onboarding) {
        context.user.onboarding_step = 4;
        context.next(4);
      }else{
        context.activeStep = 1;
        context.next(1);
      }
      clearInterval(interval);
    }
  })
};



// WEBPACK FOOTER //
// ./src/app/services/account/verifyAirlockValidation.js